import { ConfigProvider } from 'antd';
import { useSyncExternalStore } from 'react';

import { getClientAntdTheme } from './antd-theme';
import { getNotifyTheme, subscribeNotifyTheme } from './notify-theme';

interface IProps {
  children: React.ReactNode;
}

/**
 * Обёртка для статического холдера antd (регистрируется через
 * `ConfigProvider.config({ holderRender })` в index.tsx). Когда активен
 * клиентский модуль — оборачивает тостеры в его тему; иначе отдаёт дефолт antd.
 */
export const NotificationThemeProvider: React.FC<IProps> = ({ children }) => {
  const { active, mode, native } = useSyncExternalStore(
    subscribeNotifyTheme,
    getNotifyTheme
  );

  const theme = active ? getClientAntdTheme(mode, native) : undefined;

  return <ConfigProvider theme={theme}>{children}</ConfigProvider>;
};
